// @flow
import { ACTIONS } from "mmb/consts/booking"
import {
  ACTION_REQUEST as MMB_ACTION_REQUEST,
  ACTION_FAILURE as MMB_ACTION_FAILURE,
} from "mmb/scenes/AccountBooking/components/Booking/services/consts"
import {
  SUBMIT_FAILURE,
  SUBMIT_REQUEST,
} from "mmb/scenes/AccountBooking/components/Booking/services/additionalServices/consts"

export const mapActionTypeToDataDogEventName = (action: { type: string, action: any }) => {
  switch (action.type) {
    case SUBMIT_REQUEST:
    case MMB_ACTION_REQUEST:
      return [
        ACTIONS.ADDITIONAL_SERVICE_PAYMENT,
        ACTIONS.CHANGE_BAGS,
        ACTIONS.ADDITIONAL_CONTACTS,
        ACTIONS.CANCEL_BOOKING,
      ].includes(action.action)
        ? `mmb/${action.action}/request`
        : ""
    case SUBMIT_FAILURE:
    case MMB_ACTION_FAILURE:
      return [
        ACTIONS.ADDITIONAL_SERVICE_PAYMENT,
        ACTIONS.CHANGE_BAGS,
        ACTIONS.ADDITIONAL_CONTACTS,
        ACTIONS.CANCEL_BOOKING,
      ].includes(action.action)
        ? `mmb/${action.action}/failure`
        : ""

    default:
      return ""
  }
}
